import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Carousel } from 'react-bootstrap'
import { MAGIC_NUMBER } from '../../constants/magicNumbers';
import { BANNERS } from '../../constants/banners';
import { getShuffledArray } from '../../constants/util';
import { LOCAL_KEYS } from '../../constants/localStorageKeys';

const mapStateToProps = state => ({
  search: state.Search
});

class LandingBanners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      banners: getShuffledArray(BANNERS)
    }
  }

  componentDidMount() {
    const banners = [...this.state.banners];
    const cachedURL = localStorage.getItem(LOCAL_KEYS.FIRST_BANNER);
    if (!!cachedURL && cachedURL === banners[0]) {

      [banners[0], banners[banners.length - 1]] = [
        banners[banners.length - 1], banners[0]];

      this.setState({
        banners: banners
      })
    }

    localStorage.setItem(LOCAL_KEYS.FIRST_BANNER, banners[0]);
  }

  render() {
    const { banners } = this.state;
    return (
      <div className="banner-main-class">
        <Carousel controls={false} indicators={false}
          interval={MAGIC_NUMBER.BANNER_CHANGE_DELAY} fade>
          {banners.map((url, index) => (
            <Carousel.Item key={index} className="banner-image-section">
              <img
                src={url}
                style={{ width: "100%", height: "auto" }}
                alt="banner"
                className="img-banner"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    )
  }
}

export default connect(mapStateToProps)(LandingBanners);
